import { useParams } from "react-router";

const PageNotFound: React.FC = () => {
  const { page } = useParams();

  return (
    <>
      <title>{`Page ${page} Not Found`}</title>
      <div>
        Page <strong>{page}</strong> Was Not Found
      </div>
    </>
  );
};

export default PageNotFound;
